import { ReactNode, Suspense } from "react";
import styled, { CSSProperties, css } from "styled-components";
import { defaultTheme } from "../../styles/defaultTheme";
import { screens } from "../../styles/globalsStyles";

export interface ToolkitOptions {
  extraStyles?: CSSProperties;
  notToCenterX?: boolean;
}
type ToolkitProps = { children: ReactNode; options?: ToolkitOptions };
const Toolkit = ({ children, options }: ToolkitProps) => {
  return (
    <Suspense>
      <ToolkitWrap
        $notToCenterX={options?.notToCenterX}
        style={options?.extraStyles}
      >
        {children}
      </ToolkitWrap>
    </Suspense>
  );
};

const ToolkitWrap = styled.div<{ $notToCenterX?: boolean }>`
  display: flex;
  align-items: center;
  position: absolute;

  ${screens({
    desktop: css`
      /* min-width: 500px; */
    `
  })}
  padding: .5rem;
  max-width: 98vw;
  background-color: ${defaultTheme.tertiaryColor};
  /* min-height: 80px; */
  z-index: 999;
  bottom: 2rem;
  ${({ $notToCenterX }) =>
    !$notToCenterX
      ? css`
          left: 50%;
          transform: translateX(-50%);
        `
      : ""}

  border-radius: 20px;
  border: ${defaultTheme.primaryColor} 1px solid;
  opacity: 0.8;
`;

export default Toolkit;
